import { render, staticRenderFns } from "./ModalCreatePerson.vue?vue&type=template&id=5bfe8b06&scoped=true"
import script from "./ModalCreatePerson.vue?vue&type=script&lang=js"
export * from "./ModalCreatePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe8b06",
  null
  
)

export default component.exports